import { DataGrid, DataGridSkeleton } from '@cw-ui/data-grid';
import { AlertBanner } from '@cw-ui/feedback-components';
import { Menu, MenuItem } from '@cw-ui/navigation-components';
import { setMuiLicense } from '@cw-ui/utils';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Alert, Button, Paper, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ACTIVE_SCREEN_KEY, formatMessage } from 'cw-ui-core';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { handleNoUserPermissionsPresent, shouldDisableUserDetails } from 'src/features/users-v2/utils/Userutils';
import Locale from 'src/i18n';
// import { EmptyState } from '@cw-ui/asio-neon-templates';
import { AppTabsPanelContainer } from 'src/components/AppTabsPanelContainer';
import { useStylesHook } from 'src/hooks/utilHooks';
import AlertNotificationContainer from 'src/asio-neon-components/AlertNotification/AlertNotificationContainer';
import { commonDataGridProps } from 'src/features/users-v2/constants';
import usersListStyles from 'src/features/users-v2/components/NewUsers/NewUsersStyles';
import { DataGridNoRecords } from 'src/asio-neon-components/DataGridNoRecords/DataGridNoRecords';
import { Features, hasFeature } from 'src/util/featureToggles';
import { ADD_EXTERNAL_IDP, EDIT_EXTERNAL_IDP } from 'src/features/users-v2/constants';
import { getGridColumnData } from './gridColumns';

const NewUsers = props => {
    // const [mfaProvidersFilterable, setMfaProvidersFilterable] = useState(true);
    const [readOnlyMode, setReadOnlyMode] = useState(false);
    // const [isBulkOperationsDropdownOpen, setIsBulkOperationsDropdownOpen] = useState(false);

    setMuiLicense();
    const theme = useTheme();
    const isDownThanLgScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const {
        isUsersForAppRoleLoading,
        onDidMount,
        componentWillUnmount,
        users,
        selectedUsers,
        usersSearchText,
        hideIdentityRoles = false,
        isUsersReady,
        isUsersFailedToLoad,
        totalUsers,
        loginProvidersFilter,
        identityRoles,
        // filterChange,
        onSearchInputChange,
        // Commented For Auth Tab -> IAM-10203
        onPaginationChange,
        onSelection,
        // onDisableSelect,
        // onEnableSelect,
        // onDeleteSelect,
        embedded,
        appRolesGrid,
        // onResendInvite,
        // onResetPassword,
        disabledOnNoneSelect,
        disabledUnlessActiveSelect,
        disabledOnExternalAuthSelect,
        disabledUnlessPendingSelect,
        disableWhenActiveSelected,
        readOnly = false,
        // onAuthMethodSelect,
        disbaleOnDisabledSelected,
        disabledUnlessDisabledSelect,
        shouldNotShowAlert,
        screenKey,
    } = props;

    const disableResendInvite = disabledOnNoneSelect || disabledUnlessPendingSelect || disableWhenActiveSelected;
    const disableResetPassword = disabledOnNoneSelect || disabledUnlessActiveSelect || disabledOnExternalAuthSelect;
    const isDisableOptionDisabled = disabledOnNoneSelect || disbaleOnDisabledSelected;
    const isEnableOptionDisabled = disabledOnNoneSelect || disabledUnlessDisabledSelect;
    const isDeleteOptionDisabled = disabledOnNoneSelect;

    const doUserHaveOnlyUsersViewPermission = shouldDisableUserDetails(screenKey);
    const hasAssignUsersToAppRolesReadOnlyFeature = !!hasFeature(Features.USERS_ASSIGNED_TO_ROLE__READ_ONLY);

    const isReadOnlyOrEmbedded = readOnlyMode || embedded;
    const styles = useStylesHook(usersListStyles);

    const { gridColumnData, connectedAppsColumn } = getGridColumnData({
        isReadOnlyOrEmbedded,
        hideIdentityRoles,
        identityRoles,
        loginProvidersFilter,
        isDownThanLgScreen,
        readOnlyMode,
        embedded,
    });

    useEffect(() => {
        const newReadOnlyMode = readOnly || doUserHaveOnlyUsersViewPermission;
        setReadOnlyMode(newReadOnlyMode);
    }, [readOnly, doUserHaveOnlyUsersViewPermission]);

    useEffect(() => {
        if (handleNoUserPermissionsPresent(screenKey)) {
            return;
        }
        onDidMount();
        // eslint-disable-next-line consistent-return
        return () => {
            componentWillUnmount();
        };
    }, [onDidMount]);

    const handleRowUpdate = newSelectionModel => {
        if (!isEmpty(users)) {
            onSelection(newSelectionModel);
        }
    };
    const handleSearch = useCallback(
        debounce(searchValue => {
            onSearchInputChange(searchValue);
        }, 500),
        []
    );

    const EmptyStatePlaceHolder = () => (
        <DataGridNoRecords
            messageLine1={
                isUsersFailedToLoad
                    ? formatMessage(Locale.gridNoRecordsFailedMsgLine1)
                    : formatMessage(Locale.gridNoRecordsFoundMsgLine1)
            }
            messageLine2={isUsersFailedToLoad ? '' : formatMessage(Locale.gridNoRecordsFoundMsgLine2)}
        />
    );

    /* const onFilterModelChange = useCallback(
        filterModel => {
            const roles = [];
            const status = [];
            const authentication = [];
            const mfaProviders = [];
            _.forEach(filterModel?.items, item => {
                if (!_.isEmpty(item?.value)) {
                    switch (item?.field) {
                        case LOGIN_SCHEME:
                            authentication.push(...item?.value);
                            break;
                        case MFA_PROVIDERS:
                            mfaProviders.push(...item?.value);
                            break;
                        case STATUS:
                            status.push(...item?.value);
                            break;
                        case USER_ROLES:
                            roles.push(...item?.value);
                            break;
                        default:
                            break;
                    }
                }
            });

            if (_.includes(authentication, LOCAL_LOGIN) || _.isEmpty(authentication)) setMfaProvidersFilterable(true);
            else {
                setMfaProvidersFilterable(false);
                mfaProviders.length = 0;
            }

            const rolesSet = [...new Set(roles)];
            const mfaProvidersSet = [...new Set(mfaProviders)];
            const statusSet = [...new Set(status)];
            const authenticationSet = [...new Set(authentication)];

            const rolesFilter = [];
            const authenticationFilter = [];
            const statusFilter = [];
            const mfaFilter = [];

            if (!_.isEmpty(rolesSet)) {
                const rolesList = toMap(getScreenData(Store().getState().screen, ['roles'], screenKey));
                _.forEach(rolesList, roleItem => {
                    if (_.includes(rolesSet, roleItem?.name)) rolesFilter.push(roleItem?.id);
                });
            }
            _.forEach(mfaProvidersSet, mfaItem => {
                switch (mfaItem) {
                    case EMAIL_MFA:
                        mfaFilter.push(emailMfa);
                        break;
                    case AUTH_MFA:
                        mfaFilter.push(authenticatorMfa);
                        break;
                    case DUO_MFA:
                        mfaFilter.push(duoMfa);
                        break;
                    default:
                        break;
                }
            });
            _.forEach(statusSet, statusItem => {
                switch (statusItem) {
                    case ACTIVE:
                        statusFilter.push(active);
                        break;
                    case PENDING:
                        statusFilter.push(pending);
                        break;
                    case DISABLED:
                        statusFilter.push(disabledText);
                        break;
                    case EXPIRED:
                        statusFilter.push(expired);
                        break;
                    default:
                        break;
                }
            });
            if (!_.isEmpty(authenticationSet)) {
                const loginProvidersList = toMap(
                    getScreenData(Store().getState().screen, ['loginProviders'], screenKey)
                );
                if (_.includes(authenticationSet, LOCAL_LOGIN)) authenticationFilter.push(LOCAL_LOGIN);
                _.forEach(loginProvidersList, loginProviderItem => {
                    if (_.includes(authenticationSet, loginProviderItem?.name))
                        authenticationFilter.push(loginProviderItem?.scheme);
                });
            }

            filterChange(rolesFilter, authenticationFilter, statusFilter, mfaFilter, usersSearchText);
        },
        [users]
    ); */

    const handleGridData = useMemo(() => {
        if (embedded) {
            return gridColumnData;
        }
        gridColumnData.splice(4, 0, connectedAppsColumn);
        return gridColumnData;
    }, [embedded, readOnlyMode]);

    const options = [
        <MenuItem size="large">{formatMessage(Locale.updateRole)}</MenuItem>,
        <MenuItem size="large" disabled={disabledOnNoneSelect}>
            {formatMessage(Locale.setAuthMethod)}
        </MenuItem>,
        <MenuItem size="large">{formatMessage(Locale.updateMandatoryMfa)}</MenuItem>,
        <MenuItem size="large" disabled={disableResendInvite}>
            {formatMessage(Locale.resendInvite)}
        </MenuItem>,
        <MenuItem size="large" disabled={disableResetPassword}>
            {formatMessage(Locale.resetPassword)}
        </MenuItem>,
        <MenuItem size="large" disabled={isEnableOptionDisabled}>
            {formatMessage(Locale.enableUser)}
        </MenuItem>,
        <MenuItem size="large" disabled={isDisableOptionDisabled}>
            {formatMessage(Locale.disableUser)}
        </MenuItem>,
        <MenuItem size="large" disabled={isDeleteOptionDisabled}>
            {formatMessage(Locale.deleteUser)}
        </MenuItem>,
        <MenuItem size="large">{formatMessage(Locale.exportUser)}</MenuItem>,
    ];

    const HandleActionBtns = () => {
        const [anchorEl, setAnchorEl] = useState(null);
        const handleClick = useCallback(event => {
            setAnchorEl(prev => (prev ? null : event.target));
        }, []);
        if (!isReadOnlyOrEmbedded) {
            return (
                <>
                    <Button
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        aria-controls="playground-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        endIcon={<ExpandMoreIcon />}>
                        {formatMessage(Locale.actions)}
                    </Button>
                    <Menu id="playground-menu" open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClick}>
                        {options}
                    </Menu>
                    <Button color="primary" endIcon={<AddIcon />} size="medium" variant="contained">
                        {formatMessage(Locale.AddUsersButton)}
                    </Button>
                </>
            );
        }
    };

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 50,
    });
    const paginationClickHandler = useCallback(
        throttle(newPaginationModel => {
            setPaginationModel(newPaginationModel);
            onPaginationChange(newPaginationModel.page + 1, newPaginationModel.pageSize);
        }, 1500),
        []
    );

    const handlePaginationModelChange = newPaginationModel => {
        paginationClickHandler(newPaginationModel);
    };

    if (handleNoUserPermissionsPresent(screenKey)) {
        return (
            <Stack sx={{ px: 2, py: 2 }}>
                <Alert severity="warning">{formatMessage(Locale.youDontHavePermissionToViewUsers)}</Alert>
            </Stack>
        );
    }

    // Sort users based on selectedUsers to show selected users first
    let sortedUsers = users;
    if (hasAssignUsersToAppRolesReadOnlyFeature) {
        sortedUsers = [...users].sort((a, b) => {
            if (selectedUsers.includes(a.id) && !selectedUsers.includes(b.id)) {
                return -1;
            }
            if (!selectedUsers.includes(a.id) && selectedUsers.includes(b.id)) {
                return 1;
            }
            return 0;
        });
    }

    const getHeightForGridOnCurrentScreen = () => {
        // when on applications role tab
        if (screenKey === ACTIVE_SCREEN_KEY) {
            return '100%';
        }
        // on authenticaion tab
        if (screenKey === EDIT_EXTERNAL_IDP || screenKey === ADD_EXTERNAL_IDP) {
            return '95%';
        }
        return '100%';
    };

    const embeddedGridStyle = {
        height: getHeightForGridOnCurrentScreen(),
        minHeight: '40vh',
        '& .Mui-disabled .MuiSvgIcon-root': {
            fill: 'currentColor !important',
        },
        '& .MuiDataGrid-root': {
            height: '100%',
            flexGrow: 'initial',
        },
    };
    const appRoleStyles = {
        height: getHeightForGridOnCurrentScreen(),
        minHeight: '40vh',
        '& .Mui-disabled .MuiSvgIcon-root': {
            fill: 'currentColor !important',
        },
        '& .MuiDataGrid-root': {
            height: '90%',
            flexGrow: 'initial',
        },
    };

    const nonEmbeddedGridStyle = {
        height: '100%',
    };

    // Remove select all checkbox in readonly mode
    if (readOnlyMode) {
        embeddedGridStyle['& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer'] = {
            display: 'none',
        };
    }

    const getPaperStyles = () => {
        if (embedded) {
            return appRolesGrid ? appRoleStyles : embeddedGridStyle;
        } else {
            return nonEmbeddedGridStyle;
        }
    };

    let GridRootStyles = getPaperStyles();

    const componentJsx = (
        <Paper sx={GridRootStyles} className="users-datagrid-container">
            {!shouldNotShowAlert && <AlertNotificationContainer />}
            {readOnlyMode && (
                <Stack direction="row" pl={2}>
                    <AlertBanner
                        contrast="normal"
                        severity="info"
                        message={
                            screenKey === EDIT_EXTERNAL_IDP || screenKey === ADD_EXTERNAL_IDP
                                ? formatMessage(Locale.editAssignedUsersHelperText)
                                : formatMessage(Locale.editAssignedUsersAsReadOnlyHelperText)
                        }
                        data-TestId="info-alert-banner"
                        width="full"
                        sx={{
                            paddingTop: 0,
                            paddingBottom: 0,
                            '& .MuiAlertTitle-root': {
                                display: 'none',
                            },
                        }}
                    />
                </Stack>
            )}
            <DataGrid
                size="XL"
                rows={sortedUsers}
                rowCount={totalUsers}
                disableColumnFilter={embedded}
                disableColumnSelector={embedded}
                disableDensitySelector={embedded}
                columns={handleGridData}
                disableColumnMenu={isReadOnlyOrEmbedded}
                slots={{
                    loadingOverlay: () => <DataGridSkeleton columns={gridColumnData} rowLength={15} />,
                    noRowsOverlay: EmptyStatePlaceHolder,
                    noResultsOverlay: EmptyStatePlaceHolder,
                }}
                hideFooterPagination={!sortedUsers?.length && usersSearchText?.length}
                loading={!isUsersReady || isUsersForAppRoleLoading}
                sx={styles.usersList(embedded)}
                {...commonDataGridProps}
                pagination={!isReadOnlyOrEmbedded}
                density={isDownThanLgScreen ? 'compact' : 'standard'}
                // Commented For Auth Tab -> IAM-10203
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationModelChange}
                columnVisibilityModel={{
                    // Hide column status and traderName, the other columns will remain visible
                    mfaProviders: false,
                    loginScheme: false,
                }}
                slotProps={{
                    toolbar: {
                        // isFilterable: false,
                        hideActions: embedded,
                        // onResendInvite,
                        // onResetPassword,
                        // disableResetPassword,
                        // disableResendInvite,
                        // readOnly: readOnlyMode,
                        // onDeleteSelect,
                        NonBulkActions: HandleActionBtns,
                        onSearchChange: handleSearch,
                        embedded,
                    },
                }}
                isRowSelectable={() => !readOnlyMode}
                disableRowSelectionOnClick
                // onFilterModelChange={onFilterModelChange}
                onRowSelectionModelChange={handleRowUpdate}
                keepNonExistentRowsSelected
                rowSelectionModel={selectedUsers}
            />
        </Paper>
    );

    if (embedded) {
        return componentJsx;
    } else {
        return <AppTabsPanelContainer>{componentJsx}</AppTabsPanelContainer>;
    }
};

export default NewUsers;
